// LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Presentation: React.FC = () => {
    
    const { t } = useTranslation();

    return(
        <section id="presentation" className="space-pt position-relative">
            <div className="container-fluid w-90">
                <div className="row">
                    <div className="col-12">
                        <h1 className="mb-3">{t('homePage.presentation.title')}</h1>
                        <h2>{t('homePage.presentation.subTitle')}</h2>
                        <p>{t('homePage.presentation.para1')}</p>
                        <p>{t('homePage.presentation.para2')}</p>
                        <p>{t('homePage.presentation.para3')}</p>
                        <div className="text-right">
                            <Link to={'/agenzia'} title={t('homePage.presentation.linkTitle') as string} className="btn-primary ml-auto">
                                <span> {t('homePage.presentation.linkText')}</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;